import { render, staticRenderFns } from "./IntroductionDetail.vue?vue&type=template&id=17defd88&scoped=true"
import script from "./IntroductionDetail.vue?vue&type=script&lang=js"
export * from "./IntroductionDetail.vue?vue&type=script&lang=js"
import style0 from "./IntroductionDetail.vue?vue&type=style&index=0&id=17defd88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17defd88",
  null
  
)

export default component.exports